/**
 * Textos de Compres (`ca`): tall «filtres» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `ca.ts`.
 * Filtres de les llistes d'Albarans, Excepcions i Devolucions (OBR-181). Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 * El proveïdor i «Treu els filtres» reutilitzen les claus de Comandes (`backoffice.purchaseOrders`).
 */

export const filtresCa = {
  'backoffice.purchaseFilters': {
    receptionsSearch: 'Cerca per albarà, comanda, proveïdor o factura',
    receptionsStatusConfirmed: 'Confirmat',
    receptionsStatusDraft: 'Esborrany',
    receptionDateFrom: 'Recepció des de',
    receptionDateTo: 'Recepció fins a',
    receptionsEmptyFiltered: 'Cap albarà encaixa amb aquests filtres. Prova d’eixamplar-los o treu-los.',
    exceptionsSearch: 'Cerca per albarà, comanda, proveïdor o article',
    exceptionsEmptyFiltered: 'Cap excepció encaixa amb aquests filtres. Prova d’eixamplar-los o treu-los.',
    returnsSearch: 'Cerca per devolució, albarà, comanda, proveïdor, article o lot',
    returnsDateFrom: 'Creada des de',
    returnsDateTo: 'Creada fins a',
    returnsEmptyFiltered: 'Cap devolució encaixa amb aquests filtres. Prova d’eixamplar-los o treu-los.',
  },
} as const;
